"use client"
import { TextBody, Tooltip } from "@opensea/ui-kit"
import { Info } from "@opensea/ui-kit/icons"
import { useTranslations } from "use-intl"

type Props = {
  creatorFeeEnforced: boolean
  forAcceptOffersSummary?: boolean
}

export const CreatorEarningsTooltip = ({
  creatorFeeEnforced,
  forAcceptOffersSummary = false,
}: Props) => {
  const t = useTranslations("wallet.CreatorEarningsTooltip")

  return (
    <Tooltip
      content={
        forAcceptOffersSummary && creatorFeeEnforced ? (
          <TextBody>{t("enforcedForCollection")}</TextBody>
        ) : (
          <>
            <TextBody>{t("paidBySeller")}</TextBody>
            {creatorFeeEnforced && <TextBody> {t("enforced")}</TextBody>}
          </>
        )
      }
      side="bottom"
    >
      <Info fill="text-secondary" size={16} />
    </Tooltip>
  )
}
